import type { ReactNode } from 'react';
import { ProfileContainer } from './ProfileContainer';

export interface ProfileLayoutProps {
  /** The full-bleed `ProfileHero`; omitted on the individual page, whose identity is a card. */
  hero?: ReactNode;
  children: ReactNode;
}

/**
 * A profile page's frame (MYN-217 approved mockups): the header edge to edge,
 * then the cards in the 1440px content column with 32px above and 64px below.
 */
export function ProfileLayout({ hero, children }: ProfileLayoutProps) {
  return (
    <div className="flex flex-col">
      {hero}
      <ProfileContainer className="flex flex-col gap-6 pt-8 pb-16">{children}</ProfileContainer>
    </div>
  );
}
